import React from 'react';

const fomoPoints = [
  {
    text: 'No todos los alojamientos pueden estar destacados',
  },
  {
    text: 'La visibilidad se asigna por orden de ingreso',
  },
  {
    text: 'Una vez cubiertos los espacios, la campaña se cierra',
  },
  {
    text: 'Carnaval y Semana Santa no se repiten',
  },
];

const CampanaFomo = () => {
  return (
    <section className="campana-fomo">
      <div className="campana-fomo__container">
        <div className="campana-fomo__badge">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
            <path d="M12 9v4" />
            <path d="M12 17h.01" />
          </svg>
          Cupos limitados
        </div>

        <h2 className="campana-fomo__title">Si no entrás ahora, tu alojamiento compite desde atrás.</h2>

        <div className="campana-fomo__points">
          {fomoPoints.map((point, index) => (
            <div key={index} className="campana-fomo__point">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="campana-fomo__icon"
              >
                <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
                <path d="M12 9v4" />
                <path d="M12 17h.01" />
              </svg>
              <p>{point.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CampanaFomo;
